export default {
    "title": "List of data executions",
    "description": "Update data from webservice",
    "success": "SUCCESS",
    "running": "RUNNING",
    "button": "Get data",
    "error": "ERROR",
    "manual": "MANUAL",
    "automatic": "AUTOMATIC",
    "executionsTableColumns": {
        "startTime": "Start Time",
        "finishTime": "Finish Time",
        "duration": "Duration",
        "type": "Type",
        "status": "Status",
        "user": "User"
    },
    "runningExecution": "There's a running execution ongoing. Please wait until it ends.",
};